<script setup lang="ts">
const carousels = [
  {
    title: 'Unggah Data Order (Excel, CSV)'
  },
  {
    title: 'Sistem akan Otomatis Memetakan Alamat, Produk dan Ekspedisi '
  },
  {
    title:
      'Tinggal klik "Proses Semua" dan seluruh paket siap dikirim sekaligus'
  }
]
</script>

<template>
  <div
    class="bg-surface-container-low dark:bg-surface-container-highest py-6 lg:py-16 relative overflow-hidden"
  >
    <UiBgSkewY />
    <UiContainer class="flex flex-col gap-6 lg:gap-11 relative z-10">
      <UiSectionTitle
        class="lg:text-center"
        title="Dari Ratusan Data Jadi Ratusan Pengiriman Akurat Dalam Sekali Klik"
      />
      <UiCarouselFeature
        :items="carousels"
        hide-nav-button
        class-content-wrapper="overflow-visible"
      />
    </UiContainer>
  </div>
</template>
